import AIChat from '../../components/AiChat';

const AIPage = () => {
  return <AIChat />;
};

export default AIPage;
